<template>
    <c-modal
        v-model="model"
        confirmLabel="Clear Tab & Continue"
        centered size="md"
        title="Attention"
        :tag="false"
        @hide="hide"
        @submit="submit">
        <div>
            You cannot mix items from special event and today menus on the same tab.Please choose how to proceed.
        </div>
    </c-modal>
</template>

<script>
    import CModal from "../../shared/Cmodal";
    export default {
        name: "attentionRemoveItems",
        components: {CModal},
        props: {
            value: {required: true, type: Boolean, default: false}
        },
        computed: {
            model: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            }
        },
        methods: {
            hide () {
                this.model = false
            },
            submit () {
                this.$emit('submit')
            }
        }
    }
</script>

<style scoped>

</style>
